<ion-card>
  <ion-card-content>
    <div>
      <fa-icon [icon]="faQrcode" class="warning"></fa-icon>
      <span class="heure"
        >{{ declaration().instant?.toDate() | date: 'HH:mm' }} - {{ 'mainCourante.pointage' | translate }}
        @if (!declaration().parcours) {
          {{ 'mainCourante.horsParcours' | translate }}
        }
        - {{ declaration().libelle | truncate: [160, '...'] }}</span
      >
    </div>
  </ion-card-content>
</ion-card>
